import React, {useEffect, useState} from "react";
import {jwtDecode} from "jwt-decode";
import {useSelector, useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import {clearAdminUserDetails} from "./store/reducer";

const ProtectedRoute = ({children}) => {
    const {adminUserDetails} = useSelector((state) => state.admin);
    const token = adminUserDetails.token;
    const [showPage, setShowPage] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (!token) {
            navigate("/login");
            return;
        }

        try {
            const decoded = jwtDecode(token);
            const isExpired = decoded.exp * 6000 < Date.now();

            if (isExpired) {
                dispatch(clearAdminUserDetails());
                navigate("/login");
                return;
            }

            setShowPage(true);
        } catch (err) {
            console.error("Token decode error:", err);
            dispatch(clearAdminUserDetails());
            navigate("/login");
        }
    }, [token, dispatch, navigate]);

    if (!showPage) return <div>Loading...</div>;

    return <>{children}</>;
};

export default ProtectedRoute;
